import { FC, useContext } from "react";
import {
  AgentOperatorCreateServiceContext,
  AgentOperatorCreateServiceContextProvider,
} from "../../contexts/services/agentOperator/AgentOperatorCreateServiceContext";
import CrudModal from "../CrudModal";

type AgentCreateModalProps = {
  mode: string;
  isOpen: boolean;
  setOpen: Function;
  afterSave?: Function;
};
const AgentOperatorCreateModal: FC<AgentCreateModalProps> = ({
  mode,
  isOpen,
  setOpen,
  afterSave,
}) => {
  const contextAgent = useContext(AgentOperatorCreateServiceContext);

  return (
    <CrudModal
      template={[
        {
          name: "Agent",
          field: "agent",
          placeholder: "63948952f024c3e68bb13914",
          value: contextAgent.fields.agent,
          type: "text",
        },
        {
          name: "ชื่อผู้ใช้",
          field: "username",
          placeholder: "ชื่อผู้ใช้",
          value: contextAgent.fields.username,
          type: "text",
        },
        {
          name: "รหัสผ่าน",
          field: "password",
          placeholder: "รหัสผ่าน",
          value: contextAgent.fields.password,
          type: "password",
        },
        {
          name: "ประเภท",
          field: "type",
          placeholder: "ประเภท",
          value: contextAgent.fields.type,
          type: "roleOperator",
        },
      ]}
      error={contextAgent.error}
      isModalOpen={isOpen}
      onToggleModal={() => setOpen(!isOpen)}
      onUpdateField={(field: string, value: any) => {
        contextAgent.setFields(field, value);
      }}
      onSubmit={
        mode === "info" ?() => {
          contextAgent.saveFields(() => {
            setOpen(false);
            afterSave && afterSave();
          });
        }: undefined
      }
    />
  );
};

const AgentOperatorCreateModalHoc = (props: AgentCreateModalProps) => {
  return (
    <AgentOperatorCreateServiceContextProvider>
      <AgentOperatorCreateModal {...props} />
    </AgentOperatorCreateServiceContextProvider>
  );
};
export default AgentOperatorCreateModalHoc;
